import { Classroom } from 'types/classroom';
import { CJEvent } from 'types/event';
import { ClassroomsOrg } from 'types/school';
import { getClassroomToDisplayAsString } from '@teetsh/app/src/containers/CahierJournal/DayColumn/Seance/getClassroomsToDisplayAsString';

export function getGroupColumnTitle(
  events: CJEvent[],
  classrooms: Classroom[],
  classroomsOrg: ClassroomsOrg,
  nbColumns: number,
) {
  if (nbColumns <= 1) {
    return undefined;
  }
  const uniqueTitles = new Set(
    events.map(e =>
      getClassroomToDisplayAsString(
        e.classroomIds || [],
        classrooms,
        classroomsOrg,
      ),
    ),
  );
  if (uniqueTitles.size === 1) {
    // display group title if all events of the column have the same classroom to display
    return [...uniqueTitles][0];
  }
  return undefined;
}
